<template>
  <div class="dashboard">
    <!-- 统计卡片 -->
    <el-row :gutter="20" class="stats-row">
      <el-col :span="6">
        <div class="stat-card">
          <div class="stat-icon user">
            <i class="el-icon-user"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ stats.userCount || 0 }}</div>
            <div class="stat-label">用户总数</div>
          </div>
        </div>
      </el-col>
      
      <el-col :span="6">
        <div class="stat-card">
          <div class="stat-icon team">
            <i class="el-icon-s-custom"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ stats.teamCount || 0 }}</div>
            <div class="stat-label">项目总数</div>
          </div>
        </div>
      </el-col>
      
      <el-col :span="6">
        <div class="stat-card">
          <div class="stat-icon work">
            <i class="el-icon-s-order"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ stats.workCount || 0 }}</div>
            <div class="stat-label">工时记录</div>
          </div>
        </div>
      </el-col>
      
      <el-col :span="6">
        <div class="stat-card">
          <div class="stat-icon money">
            <i class="el-icon-s-finance"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">¥{{ stats.totalAmount || 0 }}</div>
            <div class="stat-label">结算总额</div>
          </div>
        </div>
      </el-col>
    </el-row>
    
    <!-- 工时类型统计 -->
    <el-row :gutter="20" class="mt-20">
      <el-col :span="12">
        <el-card>
          <div slot="header">
            <span>工时类型分布</span>
          </div>
          <div class="work-mode-stats">
            <div class="work-mode-item">
              <div class="mode-tag full-day">一天工</div>
              <div class="mode-info">
                <div class="mode-count">{{ stats.fullDayCount || 0 }} 条</div>
                <div class="mode-percent">{{ getPercent(stats.fullDayCount, stats.workCount) }}%</div>
              </div>
            </div>
            <div class="work-mode-item">
              <div class="mode-tag half-day">半天工</div>
              <div class="mode-info">
                <div class="mode-count">{{ stats.halfDayCount || 0 }} 条</div>
                <div class="mode-percent">{{ getPercent(stats.halfDayCount, stats.workCount) }}%</div>
              </div>
            </div>
            <div class="work-mode-item">
              <div class="mode-tag hour-day">小时工</div>
              <div class="mode-info">
                <div class="mode-count">{{ stats.hourDayCount || 0 }} 条</div>
                <div class="mode-percent">{{ getPercent(stats.hourDayCount, stats.workCount) }}%</div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      
      <el-col :span="12">
        <el-card>
          <div slot="header">
            <span>用户身份分布</span>
          </div>
          <div class="user-type-stats">
            <div class="user-type-item">
              <div class="type-tag worker">工人</div>
              <div class="type-info">
                <div class="type-count">{{ stats.workerCount || 0 }} 人</div>
                <div class="type-percent">{{ getPercent(stats.workerCount, stats.userCount) }}%</div>
              </div>
            </div>
            <div class="user-type-item">
              <div class="type-tag boss">包工头</div>
              <div class="type-info">
                <div class="type-count">{{ stats.bossCount || 0 }} 人</div>
                <div class="type-percent">{{ getPercent(stats.bossCount, stats.userCount) }}%</div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    
    <!-- 快捷操作 -->
    <el-row :gutter="20" class="mt-20">
      <el-col :span="12">
        <el-card>
          <div slot="header">
            <span>快捷操作</span>
          </div>
          <div class="quick-actions">
            <el-button type="primary" icon="el-icon-plus" @click="$router.push('/user')">
              用户管理
            </el-button>
            <el-button type="success" icon="el-icon-plus" @click="$router.push('/team')">
              项目管理
            </el-button>
            <el-button type="warning" icon="el-icon-plus" @click="$router.push('/work')">
              工时管理
            </el-button>
            <el-button type="info" icon="el-icon-plus" @click="$router.push('/settlement')">
              结算管理
            </el-button>
          </div>
        </el-card>
      </el-col>
      
      <el-col :span="12">
        <el-card>
          <div slot="header">
            <span>系统信息</span>
          </div>
          <div class="system-info">
            <div class="info-item">
              <span class="label">系统版本：</span>
              <span class="value">v1.0.0</span>
            </div>
            <div class="info-item">
              <span class="label">技术栈：</span>
              <span class="value">Spring Boot + Vue + Element UI</span>
            </div>
            <div class="info-item">
              <span class="label">开发团队：</span>
              <span class="value">省心记工记账开发团队</span>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {
      stats: {
        userCount: 0,
        teamCount: 0,
        workCount: 0,
        totalAmount: 0,
        fullDayCount: 0,
        halfDayCount: 0,
        hourDayCount: 0,
        workerCount: 0,
        bossCount: 0
      }
    }
  },
  created() {
    this.loadStats()
  },
  methods: {
    async loadStats() {
      try {
        const res = await this.$http.get('/admin/stats')
        this.stats = res || {}
      } catch (error) {
        console.error(error)
      }
    },
    
    getPercent(count, total) {
      if (!total || total === 0) return 0
      return ((count || 0) / total * 100).toFixed(1)
    }
  }
}
</script>

<style scoped lang="scss">
.dashboard {
  .stats-row {
    .stat-card {
      display: flex;
      align-items: center;
      padding: 20px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      
      .stat-icon {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        
        i {
          font-size: 30px;
          color: #fff;
        }
        
        &.user {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        }
        
        &.team {
          background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
        }
        
        &.work {
          background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
        }
        
        &.money {
          background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
        }
      }
      
      .stat-info {
        flex: 1;
        
        .stat-value {
          font-size: 28px;
          font-weight: bold;
          color: #333;
          margin-bottom: 5px;
        }
        
        .stat-label {
          font-size: 14px;
          color: #999;
        }
      }
    }
  }
  
  // 工时类型统计
  .work-mode-stats {
    .work-mode-item {
      display: flex;
      align-items: center;
      padding: 15px 0;
      border-bottom: 1px solid #f0f0f0;
      
      &:last-child {
        border-bottom: none;
      }
      
      .mode-tag {
        padding: 6px 16px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 500;
        margin-right: 20px;
        
        &.full-day {
          background-color: #ff7a00;
          color: #fff;
        }
        
        &.half-day {
          background: linear-gradient(135deg, transparent 50%, #ff7a00 50%);
          color: #ff7a00;
        }
        
        &.hour-day {
          background: linear-gradient(135deg, transparent 50%, #722ed1 50%);
          color: #722ed1;
        }
      }
      
      .mode-info {
        flex: 1;
        display: flex;
        justify-content: space-between;
        
        .mode-count {
          font-size: 16px;
          font-weight: bold;
          color: #333;
        }
        
        .mode-percent {
          font-size: 14px;
          color: #999;
        }
      }
    }
  }
  
  // 用户身份统计
  .user-type-stats {
    .user-type-item {
      display: flex;
      align-items: center;
      padding: 15px 0;
      border-bottom: 1px solid #f0f0f0;
      
      &:last-child {
        border-bottom: none;
      }
      
      .type-tag {
        padding: 6px 16px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 500;
        margin-right: 20px;
        
        &.worker {
          background-color: #409EFF;
          color: #fff;
        }
        
        &.boss {
          background-color: #E6A23C;
          color: #fff;
        }
      }
      
      .type-info {
        flex: 1;
        display: flex;
        justify-content: space-between;
        
        .type-count {
          font-size: 16px;
          font-weight: bold;
          color: #333;
        }
        
        .type-percent {
          font-size: 14px;
          color: #999;
        }
      }
    }
  }
  
  .quick-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .system-info {
    .info-item {
      display: flex;
      padding: 10px 0;
      border-bottom: 1px solid #f0f0f0;
      
      &:last-child {
        border-bottom: none;
      }
      
      .label {
        width: 100px;
        color: #666;
      }
      
      .value {
        flex: 1;
        color: #333;
      }
    }
  }
}
</style>
